import { apiRequest } from '../Api/ApiRequest'
import {
    SERVICE_DETAIL_INCLUDES,
    TServiceDetailInclude,
} from 'types/serviceView'

const getServiceHeaders = () => ({
    Accept: 'application/json',
    Authorization: `bearer ${localStorage.getItem('hso-api-token')}`,
})

const encodePathParam = (value: string): string => encodeURIComponent(value)

export const formatUsageMonth = (month: number | string): string => {
    const numericMonth = Number(month)

    if (Number.isNaN(numericMonth) || numericMonth < 1 || numericMonth > 12) {
        throw new Error('Invalid month')
    }

    return String(numericMonth).padStart(2, '0')
}

export const formatUsageYear = (year: number | string): string => {
    const stringYear = String(year)

    if (!/^[0-9]{4}$/.test(stringYear)) {
        throw new Error('Invalid year')
    }

    return stringYear
}

const buildQueryString = (
    params: Record<string, string | number | undefined>
) => {
    const query = new URLSearchParams()

    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== '') {
            query.set(key, String(value))
        }
    })

    const serialized = query.toString()
    return serialized ? `?${serialized}` : ''
}

export const buildServiceDetailUrl = (
    product: string,
    includes: readonly TServiceDetailInclude[] = []
): string => {
    const includeValue = includes.length ? includes.join(',') : undefined

    return `/services/${encodePathParam(product)}${buildQueryString({
        include: includeValue,
    })}`
}

export const buildServiceUsageUrl = (
    product: string,
    month: number | string,
    year: number | string
): string =>
    `/services/${encodePathParam(product)}/usage${buildQueryString({
        month: formatUsageMonth(month),
        year: formatUsageYear(year),
    })}`

export const buildServiceGraphUrl = (
    product: string,
    graphId: string,
    start: number,
    end: number
): string =>
    `/services/${encodePathParam(product)}/graph/${encodePathParam(
        graphId
    )}${buildQueryString({
        start,
        end,
    })}`

const request = (url: string) =>
    apiRequest({
        url,
        method: 'get',
        headers: getServiceHeaders(),
    })
        .then((response) => response)
        .catch((error) => error)

export { SERVICE_DETAIL_INCLUDES }

export const listServices = () => request('/services')

export const getService = (
    product: string,
    includes: readonly TServiceDetailInclude[] = SERVICE_DETAIL_INCLUDES
) => request(buildServiceDetailUrl(product, includes))

export const getServiceUsage = (
    product: string,
    month: number | string,
    year: number | string
) => request(buildServiceUsageUrl(product, month, year))

export const getServiceGraph = (
    product: string,
    graphId: string,
    start: number,
    end: number
) => request(buildServiceGraphUrl(product, graphId, start, end))
